import { useMemo } from 'react'

import { useAppSelector } from 'hooks/reduxHooks'
import { getCurrentUserId, selectRecDomainUserId } from 'selectors/accountSelectors'
import useOfferList from './useOfferList'

export function getRankedOfferListWithFallback(offerList: App.OfferList, rankedOfferList: App.OfferList): App.OfferList {
  if (!rankedOfferList.fetching && !rankedOfferList.error && rankedOfferList.offerIds.length > 0) {
    return rankedOfferList
  }

  return offerList
}

function useLereRankedOfferList(filters: App.OfferListFilters, options: { disabled: boolean }): App.OfferList {
  const leUserId = useAppSelector(getCurrentUserId)
  const domainUserId = useAppSelector(selectRecDomainUserId)
  const candidateOfferList = useOfferList(filters, { disabled: options.disabled })
  const rankerOfferIds = candidateOfferList.offerIds.join(',')
  const rankerFilters = useMemo<App.OfferListFilters | undefined>(() => {
    if (!rankerOfferIds) return undefined

    return {
      lere: 'ranker',
      leUserId,
      domainUserId,
      rankerOfferIds,
    }
  }, [domainUserId, leUserId, rankerOfferIds])

  const rankedOfferList = useOfferList(rankerFilters, { disabled: options.disabled || !rankerFilters })

  return getRankedOfferListWithFallback(candidateOfferList, rankedOfferList)
}

export default useLereRankedOfferList
